import axios from './axios';

const localeStrings = {
    en: {
        search: 'Search',
        award: 'Award',
        year: 'Year',
        category: 'Category',
        distinction: 'Distinction',
        tags: 'Tags',
        manufacturer: 'Manufacturer',
        location: 'Location',
        client: 'Client',
        projectBy: 'Project by',
        jurytext: 'Jury statement',
        all: 'All',
        loading: 'Loading...',
        showInWorld: 'Show on Iconic Directory',
        noResults: 'No results could be found.',
        loadMore: 'Load more projects',
        galleryCounter: '%curr% of %total%',
    },
    de: {
        search: 'Suche',
        award: 'Award',
        year: 'Jahr',
        category: 'Kategorie',
        distinction: 'Auszeichnung',
        tags: 'Tags',
        manufacturer: 'Hersteller',
        location: 'Standort',
        client: 'Auftraggeber',
        projectBy: 'Projekt von',
        jurytext: 'Jurybegründung',
        all: 'Alle',
        loading: 'Lädt...',
        showInWorld: 'Im Iconic Directory ansehen',
        noResults: 'Zu Ihrer Suche konnten keine Ergebnisse gefunden werden.',
        loadMore: 'Weitere Projekte laden',
        galleryCounter: '%curr% von %total%',
    }
};

window.iconicLocale = document.documentElement.lang;
const locale = window.iconicLocale || 'de';

axios.defaults.params = { locale };

export default localeStrings[locale];
